// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"2cfe2a47","66":"91db2fe9","79":"4cd2bc70","107":"dd3864b8","133":"a8242b50","190":"04da62ef","247":"2cfb41e6","258":"4279511d","290":"3dc046d3","511":"78e7752d","630":"a92de6db","689":"47833c50","752":"eda91ee4"}[chunkId] + ".chunk.js";
};